import * as React from "react";
import "../AdminSetup.css";
import { IGenericsLang } from "../../../services/Language/Types";
import { SettingOption } from "../Types";
import { AdminOptionRow } from "./AdminOptionRow";

export interface IApplicationSettings {
    textString: IGenericsLang;
    settingsOptions: SettingOption[];
    changeAdminSettingNumberField: (field: string, value: number) => void
}

export const Settings = (props: IApplicationSettings) => (
    <div>
        <table className="table no-border">
            <tbody style={{ border: "none" }}>
                {
                    props.settingsOptions.map((opts, index) => {
                        return AdminOptionRow(opts, index);
                    })
                }
            </tbody>
        </table>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/AdminSetupPage/Tabs/SettingsTabs.tsx